var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 47.909,
    viewBox: "0 0 34 47.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "baseball",
    transform: "translate(-10 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4880",
    "data-name": "Group 4880",
    transform: "translate(10.773 1.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4858",
    "data-name": "Group 4858",
    transform: "translate(14.682 29.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7271",
    "data-name": "Path 7271",
    d: "M32.82,40.672a1.545,1.545,0,1,1-2.55,0,1.545,1.545,0,0,1,2.55,0Z",
    transform: "translate(-30 -40)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4859",
    "data-name": "Group 4859",
    transform: "translate(0 31.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7272",
    "data-name": "Path 7272",
    d: "M17.182,42.68V56.064H11V49.712A7.094,7.094,0,0,1,14.493,43.6a7.212,7.212,0,0,1,1.623-.7A6.211,6.211,0,0,1,17.182,42.68Z",
    transform: "translate(-11 -42.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4860",
    "data-name": "Group 4860",
    transform: "translate(26.273 31.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7273",
    "data-name": "Path 7273",
    d: "M51.182,49.712v6.352H45V42.68a6.212,6.212,0,0,1,1.066.216,7.1,7.1,0,0,1,5.115,6.815Z",
    transform: "translate(-45 -42.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4861",
    "data-name": "Group 4861",
    transform: "translate(6.182 24.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7274",
    "data-name": "Path 7274",
    d: "M26.295,37.091H19.773a2.227,2.227,0,0,0-.6.085,2.264,2.264,0,0,1-.17-.858A2.315,2.315,0,0,1,21.318,34h4.636v1.182A5.456,5.456,0,0,0,26.295,37.091Z",
    transform: "translate(-19 -34)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4862",
    "data-name": "Group 4862",
    transform: "translate(4.636 27.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7275",
    "data-name": "Path 7275",
    d: "M27.045,41.091H24.727l-1,.085-4.86.4c-.108.008-.216.023-.325.039a6.212,6.212,0,0,0-1.066.216l-.046-.178A2.283,2.283,0,0,1,17,40.318a2.307,2.307,0,0,1,1.715-2.233,2.227,2.227,0,0,1,.6-.085H25.84a5.519,5.519,0,0,0,1.476,2.218,1.538,1.538,0,0,0-.27.873Z",
    transform: "translate(-17 -38)",
    fill: "#f9a720"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4863",
    "data-name": "Group 4863",
    transform: "translate(18.978 24.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7276",
    "data-name": "Path 7276",
    d: "M42.855,36.318a2.264,2.264,0,0,1-.17.858,2.227,2.227,0,0,0-.6-.085H35.56a5.456,5.456,0,0,0,.34-1.909V34h4.636A2.315,2.315,0,0,1,42.855,36.318Z",
    transform: "translate(-35.56 -34)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4864",
    "data-name": "Group 4864",
    transform: "translate(17.502 27.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7277",
    "data-name": "Path 7277",
    d: "M43.966,40.318a2.283,2.283,0,0,1-.433,1.337l-.046.178a6.212,6.212,0,0,0-1.066-.216c-.108-.015-.216-.031-.325-.039l-4.86-.4-1-.085H33.92a1.538,1.538,0,0,0-.27-.873l.008-.008A5.528,5.528,0,0,0,35.126,38h6.522a2.227,2.227,0,0,1,.6.085A2.307,2.307,0,0,1,43.966,40.318Z",
    transform: "translate(-33.65 -38)",
    fill: "#f9a720"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4865",
    "data-name": "Group 4865",
    transform: "translate(17.889 30.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7278",
    "data-name": "Path 7278",
    d: "M42.534,42.55V55.934H35.58V49.752a3.085,3.085,0,0,0-1.43-2.6l3.2-5.038,4.86.4C42.318,42.52,42.426,42.535,42.534,42.55Z",
    transform: "translate(-34.15 -42.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4866",
    "data-name": "Group 4866",
    transform: "translate(11.367 30.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7279",
    "data-name": "Path 7279",
    d: "M35.431,42.085l-3.2,5.038a3.078,3.078,0,0,0-3.323,0l-3.2-5.038,1-.085h2.318a1.545,1.545,0,1,0,3.091,0h2.318Z",
    transform: "translate(-25.71 -42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4867",
    "data-name": "Group 4867",
    transform: "translate(6.182 30.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7280",
    "data-name": "Path 7280",
    d: "M29.045,52.843v3.091H19V42.55c.108-.015.216-.031.325-.039l4.86-.4,3.2,5.038a3.089,3.089,0,0,0,1.661,5.695Z",
    transform: "translate(-19 -42.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4868",
    "data-name": "Group 4868",
    transform: "translate(13.136 35.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7281",
    "data-name": "Path 7281",
    d: "M34.182,57.273v1.545H31.091V54.182a3.089,3.089,0,0,1-1.661-5.7,3.091,3.091,0,0,1,4.752,2.6Z",
    transform: "translate(-28 -48)",
    fill: "#f9a720"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4869",
    "data-name": "Group 4869",
    transform: "translate(13.136 24.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7282",
    "data-name": "Path 7282",
    d: "M28,33.35a7.071,7.071,0,0,0,2.635.5h.912a7.071,7.071,0,0,0,2.635-.5v1.685a5.456,5.456,0,0,1-.34,1.909,5.528,5.528,0,0,1-1.468,2.21l-.008.008a1.545,1.545,0,0,0-2.55,0,5.519,5.519,0,0,1-1.476-2.218A5.456,5.456,0,0,1,28,35.035V33.358Z",
    transform: "translate(-28 -33.35)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4870",
    "data-name": "Group 4870",
    transform: "translate(5.409 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7283",
    "data-name": "Path 7283",
    d: "M27.273,2h1.545a8.969,8.969,0,0,0-4.636,7.727H22.466A1.379,1.379,0,0,0,21.091,11.1a1.2,1.2,0,0,0,.008.17H18A9.26,9.26,0,0,1,27.273,2Z",
    transform: "translate(-18 -2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4871",
    "data-name": "Group 4871",
    transform: "translate(16.227 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7284",
    "data-name": "Path 7284",
    d: "M42.818,11.273h-3.1a1.2,1.2,0,0,0,.008-.17,1.378,1.378,0,0,0-1.375-1.375H36.636A8.969,8.969,0,0,0,32,2h1.545A9.27,9.27,0,0,1,42.818,11.273Z",
    transform: "translate(-32 -2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4872",
    "data-name": "Group 4872",
    transform: "translate(11.591 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7285",
    "data-name": "Path 7285",
    d: "M30.636,2a8.969,8.969,0,0,1,4.636,7.727H26A8.969,8.969,0,0,1,30.636,2Z",
    transform: "translate(-26 -2)",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4873",
    "data-name": "Group 4873",
    transform: "translate(8.5 7.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7286",
    "data-name": "Path 7286",
    d: "M36.079,12a1.378,1.378,0,0,1,1.375,1.375,1.2,1.2,0,0,1-.008.17c-.008.054-.023.108-.031.162l-.147.587a3.1,3.1,0,0,1-1.182,1.746,3.043,3.043,0,0,1-1.816.595H25.184a3.043,3.043,0,0,1-1.816-.595,3.1,3.1,0,0,1-1.182-1.746l-.147-.587c-.008-.054-.023-.108-.031-.162a1.2,1.2,0,0,1-.008-.17A1.378,1.378,0,0,1,23.375,12h12.7Z",
    transform: "translate(-22 -12)",
    fill: "#ffc729"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4874",
    "data-name": "Group 4874",
    transform: "translate(5.409 9.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7287",
    "data-name": "Path 7287",
    d: "M22.459,16.5l-.595.595h-.773A3.09,3.09,0,0,0,18,20.182V14h3.1c.008.054.023.108.031.162l.147.587A3.1,3.1,0,0,0,22.459,16.5Z",
    transform: "translate(-18 -14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4875",
    "data-name": "Group 4875",
    transform: "translate(22.587 9.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7288",
    "data-name": "Path 7288",
    d: "M43.785,18a3.11,3.11,0,0,0-2.187-.9h-.773l-.6-.6a3.1,3.1,0,0,0,1.182-1.746l.147-.587c.008-.054.023-.108.031-.162h3.1v6.182A3.11,3.11,0,0,0,43.785,18Z",
    transform: "translate(-40.23 -14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4876",
    "data-name": "Group 4876",
    transform: "translate(23.182 12.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7289",
    "data-name": "Path 7289",
    d: "M43.96,18.9a3.093,3.093,0,0,1-2.187,5.278h-.085a7.209,7.209,0,0,0,.085-1.082V19.414a1.55,1.55,0,0,0-.456-1.1L41,18h.773A3.11,3.11,0,0,1,43.96,18.9Z",
    transform: "translate(-41 -18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4877",
    "data-name": "Group 4877",
    transform: "translate(8.5 11.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7290",
    "data-name": "Path 7290",
    d: "M25.184,17.825h9.087a3.043,3.043,0,0,0,1.816-.595l.595.595.317.317a1.55,1.55,0,0,1,.456,1.1v3.686a7.359,7.359,0,0,1-1.685,4.652,7.121,7.121,0,0,1-1.623,1.43l-.4-3.624a1.548,1.548,0,0,0-1.538-1.375H27.247a1.548,1.548,0,0,0-1.538,1.375l-.4,3.624a7.121,7.121,0,0,1-1.623-1.43,7.218,7.218,0,0,1-1.6-3.57L22,22.925V19.239a1.55,1.55,0,0,1,.456-1.1l.317-.317.595-.6a3.043,3.043,0,0,0,1.816.6Z",
    transform: "translate(-22 -17.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4878",
    "data-name": "Group 4878",
    transform: "translate(5.409 12.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7291",
    "data-name": "Path 7291",
    d: "M21.091,19.414V23.1l.085,1.082h-.085a3.091,3.091,0,0,1,0-6.182h.773l-.317.317A1.55,1.55,0,0,0,21.091,19.414Z",
    transform: "translate(-18 -18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4879",
    "data-name": "Group 4879",
    transform: "translate(11.807 18.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7292",
    "data-name": "Path 7292",
    d: "M26.28,31l.4-3.624A1.548,1.548,0,0,1,28.22,26H33.18a1.548,1.548,0,0,1,1.538,1.375L35.12,31a5.473,5.473,0,0,1-.881.495,4.554,4.554,0,0,1-.448.185,7.071,7.071,0,0,1-2.635.5h-.912a7.071,7.071,0,0,1-2.635-.5A6.166,6.166,0,0,1,26.28,31Z",
    transform: "translate(-26.28 -26)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4881",
    "data-name": "Group 4881",
    transform: "translate(10 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7293",
    "data-name": "Path 7293",
    d: "M44,40.238a7.848,7.848,0,0,0-4.84-7.254,3.047,3.047,0,0,0,.2-1.075,3.082,3.082,0,0,0-1.585-2.683,3.013,3.013,0,0,0,.039-.408,3.094,3.094,0,0,0-3.091-3.091h-2.54a7.915,7.915,0,0,0,3.1-4.693,3.858,3.858,0,0,0,3.3-3.807V11.045A10.057,10.057,0,0,0,28.545,1H25.455A10.057,10.057,0,0,0,15.409,11.045v6.182a3.858,3.858,0,0,0,3.3,3.807,7.915,7.915,0,0,0,3.1,4.693H19.273a3.094,3.094,0,0,0-3.091,3.091,3.013,3.013,0,0,0,.039.408,3.082,3.082,0,0,0-1.585,2.683,3.047,3.047,0,0,0,.2,1.075A7.848,7.848,0,0,0,10,40.238v7.125H26.227v1.545h4.636V47.364H44Zm-6.33-7.715a7.909,7.909,0,0,0-.882-.124l-5.925-.491h-1.61a6.367,6.367,0,0,0,1.008-1.545h6.01a1.547,1.547,0,0,1,1.545,1.545A1.506,1.506,0,0,1,37.67,32.523ZM27,36.545a3.823,3.823,0,0,0-1.375.264L23.49,33.455h1.334a2.3,2.3,0,0,0,4.352,0l1.335,0L28.375,36.81A3.823,3.823,0,0,0,27,36.545Zm-2.318-9.494a8.045,8.045,0,0,0,1.858.221h.919a8.046,8.046,0,0,0,1.858-.222v.629a4.828,4.828,0,0,1-1.09,3.043,2.276,2.276,0,0,0-2.455,0,4.826,4.826,0,0,1-1.09-3.042ZM23.4,24.911l.348-3.133a.774.774,0,0,1,.769-.688H29.48a.772.772,0,0,1,.768.688l.348,3.133a6.473,6.473,0,0,1-3.136.816h-.919a6.479,6.479,0,0,1-3.138-.816Zm3.6,7a.773.773,0,1,1-.773.773A.774.774,0,0,1,27,31.909Zm9.273-3.091H30.754a6.346,6.346,0,0,0,.11-1.137v-.408h3.864A1.547,1.547,0,0,1,36.273,28.818ZM20.21,11.608l-.146-.583a.6.6,0,0,1,.585-.752h12.7a.6.6,0,0,1,.6.6.624.624,0,0,1-.018.146l-.146.586a2.315,2.315,0,0,1-2.249,1.756H22.459a2.314,2.314,0,0,1-2.249-1.756ZM27,2.664a8.109,8.109,0,0,1,3.823,6.063H23.177A8.109,8.109,0,0,1,27,2.664Zm8.492,16.741c0-.058.008-.115.008-.173V15.55a2.31,2.31,0,0,0-.063-.518,2.3,2.3,0,0,1,.056,4.374Zm1.553-5.249a3.824,3.824,0,0,0-2.318-.793h-.109a3.832,3.832,0,0,0,.671-1.381l.042-.165h1.715Zm-.035-3.884H35.4a2.145,2.145,0,0,0-2.052-1.545H32.37A9.323,9.323,0,0,0,29.406,2.59a8.514,8.514,0,0,1,7.605,7.682ZM24.595,2.591a9.322,9.322,0,0,0-2.963,6.136h-.982A2.145,2.145,0,0,0,18.6,10.273H16.99A8.512,8.512,0,0,1,24.595,2.591Zm-5.925,9.227.041.164a3.849,3.849,0,0,0,.671,1.382h-.109a3.824,3.824,0,0,0-2.318.793V11.818Zm-1.715,5.409a2.313,2.313,0,0,1,1.609-2.2,2.31,2.31,0,0,0-.063.518v3.683c0,.058.006.115.008.173a2.313,2.313,0,0,1-1.553-2.178Zm3.091,2.005V15.55A.769.769,0,0,1,20.272,15l.494-.494a3.85,3.85,0,0,0,1.693.4h9.083a3.85,3.85,0,0,0,1.693-.4l.494.494a.771.771,0,0,1,.226.547v3.683a6.508,6.508,0,0,1-1.505,4.158c-.131.158-.273.305-.417.448l-.248-2.232a2.315,2.315,0,0,0-2.3-2.062H24.52a2.315,2.315,0,0,0-2.3,2.062l-.248,2.231c-.145-.143-.286-.291-.417-.448a6.507,6.507,0,0,1-1.505-4.158Zm-.773,8.04h3.864v.408a6.346,6.346,0,0,0,.11,1.137H17.727A1.547,1.547,0,0,1,19.273,27.273Zm-3.091,4.636a1.547,1.547,0,0,1,1.545-1.545h6.01a6.386,6.386,0,0,0,1.008,1.546l-1.673,0-5.86.488a7.909,7.909,0,0,0-.882.124A1.494,1.494,0,0,1,16.182,31.909Zm-4.636,8.329a6.3,6.3,0,0,1,4.636-6.084V45.818H11.545Zm6.182,5.58V33.907l4.006-.335,2.586,4.065a3.856,3.856,0,0,0,1.908,6.558v1.624Zm11.591,1.545H27.773V42.727H27a2.318,2.318,0,1,1,2.318-2.318Zm.362-9.727,2.586-4.063,4.007.335v11.91H30.864V40.409a3.849,3.849,0,0,0-1.183-2.773Zm12.774,8.182H37.818V34.155a6.3,6.3,0,0,1,4.636,6.084Z",
    transform: "translate(-10 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7294",
    "data-name": "Path 7294",
    d: "M30,7h3.091V8.545H30Z",
    transform: "translate(-14.545 -2.364)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_373",
    "data-name": "Ellipse 373",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(13 15.954)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(20 15.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7295",
    "data-name": "Path 7295",
    d: "M33.026,29.915l.854-.427L33.188,28.1l-.854.427a2.544,2.544,0,0,1-2.237,0l-.854-.427-.692,1.382.855.427a4.046,4.046,0,0,0,3.619,0Z",
    transform: "translate(-14.216 -7.16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.e37baf028230ad4409b77d055826ca7d.svg";
export { ForwardRef as ReactComponent };